
const privacyBody = `**1. Titolare del trattamento / Verantwortlicher**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Dati che raccogliamo**

Quando utilizzi il modulo di contatto di questo sito, raccogliamo i seguenti dati: nome, indirizzo e-mail, rotta di interesse e il messaggio che ci invii. Questi dati sono necessari per risponderti.

Il sito può memorizzare cookie tecnici strettamente necessari al funzionamento di base. Non utilizziamo cookie di tracciamento o pubblicitari di terze parti.

**3. Finalità del trattamento**

I dati del modulo sono utilizzati esclusivamente per rispondere alla tua richiesta e gestire la tua registrazione iniziale sulla piattaforma. Non sono ceduti a terzi senza il tuo consenso, salvo obbligo di legge.

**4. Base giuridica**

Il trattamento si basa sul tuo consenso (art. 6, par. 1, lett. a GDPR) all’invio del modulo e sull’interesse legittimo di gestire il rapporto precontrattuale (art. 6, par. 1, lett. b GDPR).

**5. Conservazione dei dati**

I dati del modulo di contatto sono conservati per il tempo necessario a gestire la richiesta e, al massimo, per 12 mesi dall’ultimo contatto, salvo che un rapporto contrattuale successivo richieda un periodo più lungo.

**6. I tuoi diritti**

Hai diritto di: accedere ai tuoi dati personali, chiederne la rettifica o la cancellazione, opporti al trattamento, chiedere la portabilità dei dati e presentare reclamo all’autorità di protezione dei dati competente.

Per esercitare i tuoi diritti scrivici a: bringylatam@gmail.com

**7. Hosting**

Questo sito è ospitato su Cloudflare. Cloudflare può trattare dati tecnici di accesso (indirizzo IP, browser, data e ora) nell’ambito del suo servizio di rete e sicurezza. Per maggiori informazioni: https://www.cloudflare.com/privacypolicy/

**8. Modifiche a questa policy**

Possiamo aggiornare questa informativa in qualsiasi momento. La versione vigente sarà sempre disponibile in questa pagina con la data dell’ultimo aggiornamento.`

const impressumBody = `Informazioni ai sensi del § 5 TMG / Información según § 5 TMG

**Verantwortlich / Responsabile:**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Kontakt / Contatto:**
E-Mail: bringylatam@gmail.com
Telefon / Telefono: [COMPLETAR: +49 ... o número correspondiente]

**Gestore della piattaforma:**
Bringy
[COMPLETAR: misma dirección legal]

**Partita IVA / identificativo fiscale (se applicabile):**
[COMPLETAR: DE... o número fiscal del país de registro]

**Nota sulla responsabilità:**
Bringy opera come piattaforma intermediaria tra acquirenti e viaggiatori. Non siamo parte contrattuale nelle transazioni tra utenti e non assumiamo responsabilità per i prodotti scambiati, salvo nei casi espressamente previsti dai nostri Termini di utilizzo.

Le informazioni su questo sito sono state compilate con cura; tuttavia non garantiamo l’accuratezza, la completezza o l’aggiornamento.

**Risoluzione delle controversie:**
La Commissione europea mette a disposizione una piattaforma per la risoluzione delle controversie online (ODR): https://ec.europa.eu/consumers/odr
Non siamo disposti né obbligati a partecipare a procedure di composizione delle controversie dinanzi a un organismo di risoluzione extragiudiziale delle controversie dei consumatori.`

export const it = {
  brand: {
    name: 'Bringy',
    tagline: 'Persone reali. Prodotti reali. Rotte verificate.',
  },
  nav: {
    howItWorks: 'Come funziona',
    whyUs: 'Perché Bringy',
    offerings: 'Servizi',
    faq: 'FAQ',
    contact: 'Contatti',
    cta: 'Inizia',
  },
  hero: {
    eyebrow: 'Europa ↔ Sudamerica',
    titleAccent: 'Bring',
    titleRest: 'Ciò che conta.',
    subtitle:
      'Mettiamo in contatto chi viaggia tra Europa e Sudamerica con chi ha bisogno di prodotti dall’altra parte. Niente corriere, niente agenzie — solo persone reali con identità verificata.',
    ctaBuscar: 'Cerca un prodotto',
    ctaOfrecer: 'Offri come viaggiatore',
    trustBadges: [
      { label: 'Identità verificata' },
      { label: 'Pagamento in escrow' },
      { label: 'Punteggio pubblico del viaggiatore' },
      { label: 'Consegna documentata' },
    ],
    boardingPass: {
      passengerLabel: 'PASSEGGERO',
      brand: 'BRINGY',
      sub: 'TRASPORTO · VERIFICATO · ASSICURATO',
      fromCode: 'BER',
      fromCity: 'BERLINO',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'VOLO BR · 2026',
      gate: 'VARCO A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'Bringy è in fase di lancio. Ogni nuovo viaggiatore viene verificato personalmente dal nostro team.',
    processTitle: 'Prima che un viaggiatore trasporti anche un solo articolo',
    processIntro:
      'Mostriamo il rigore del processo — non testimonianze inventate. Così costruiamo fiducia fin dal primo giorno.',
    stepVerified: 'Verificato',
    stepPending: 'In attesa',
    processSteps: [
      {
        number: '01',
        title: 'Verifica dell’identità',
        description: 'Documento ufficiale convalidato prima di operare sulla piattaforma.',
      },
      {
        number: '02',
        title: 'Onboarding in videocall',
        description: 'Primo colloquio con il nostro team per spiegare regole e aspettative.',
      },
      {
        number: '03',
        title: 'Accordo sull’escrow',
        description: 'Accettazione dei termini di pagamento protetto prima della prima transazione.',
      },
    ],
    foundingMembers: '{count} viaggiatori hanno già registrato la loro prima rotta',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Perché Bringy',
    headline: 'Quattro garanzie.',
    headlineAccent: 'Nessuna eccezione.',
    title: 'Perché Bringy funziona',
    subtitle:
      'Le soluzioni informali ci sono già — gruppi WhatsApp, passaparola. Bringy fa la stessa cosa, con l’infrastruttura che mancava.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'CONFERMATO',
    cardPending: 'IN ATTESA',
    cardApproved: '· APPROVATO ·',
    cardsMeta: [
      { value: 'IDENTITÀ', field: 'KYC · PASSAPORTO' },
      { value: 'ASSICURAZIONE', field: 'FINO A €4.000' },
      { value: 'CONFORMITÀ', field: 'EU · AR · DICHIARATO' },
      { value: 'CONSEGNA', field: 'FOTO · TRACCIATA' },
    ],
    items: [
      {
        title: 'Fiducia verificabile',
        description:
          'Ogni viaggiatore supera una verifica d’identità prima di operare sulla piattaforma. Sai con chi stai trattando.',
      },
      {
        title: 'I tuoi soldi, protetti',
        description:
          'I fondi restano in escrow finché non confermi la ricezione del prodotto. Nessun rischio di pagare qualcosa che non arriva.',
      },
      {
        title: 'Reputazione reale',
        description:
          'Ogni viaggiatore accumula storico di consegne e valutazioni. Puoi vedere il punteggio prima di coordinarti.',
      },
      {
        title: 'Consegna documentata',
        description:
          'Per maggiore sicurezza offriamo verifica live con un rappresentante Bringy in videoconferenza.',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · Come funziona',
    headline: 'Una pista, non',
    headlineAccent: 'un processo.',
    tagline: 'Quattro passi. Una traversata atlantica.',
    title: 'Come funziona',
    subtitle: '',
    footerLabels: { status: 'STATO', eta: 'ETA', lane: 'CORSIA' },
    stepMeta: [
      { status: 'IN ATTESA', eta: '~ 18H', lane: 'A7' },
      { status: 'IN ATTESA', eta: '~ 36H', lane: 'B8' },
      { status: 'IN ATTESA', eta: '~ 54H', lane: 'C9' },
      { status: 'IN ATTESA', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Pubblica la tua richiesta',
        description:
          'Descrivi il prodotto di cui hai bisogno, la destinazione e cosa offri per il servizio di trasporto.',
      },
      {
        number: 2,
        title: 'Un viaggiatore accetta',
        description:
          'Viaggiatori verificati con rotte attive vedono la tua richiesta e si offrono di portarlo nel prossimo viaggio.',
      },
      {
        number: 3,
        title: 'Coordinate i dettagli',
        description:
          'Concordate modalità di pagamento, punto di ritiro e tempistiche direttamente con il viaggiatore tramite la chat della piattaforma.',
      },
      {
        number: 4,
        title: 'Ricevi e confermi',
        description:
          'Quando hai il prodotto, confermi la consegna e il pagamento viene rilasciato al viaggiatore.',
      },
    ],
  },
  manifest: {
    sectionLabel: '04 · Manifesto di oggi',
    headline: 'Il tabellone,',
    headlineAccent: 'in diretta.',
    tagline: 'Tutti gli invii dichiarati.',
    liveLabel: 'In diretta · {count} invii oggi',
    columns: ['Ora', 'Da → A', 'Invio', 'Stato', 'Varco'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'FARMACI', status: 'ASSICURATO', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ELETTRONICA', status: 'VERIFICATO', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'CALZATURE', status: 'IMBARCO', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOCUMENTI', status: 'ASSICURATO', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'LIBRI', status: 'ABBIMATO', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifesto 2026',
    footerRight: 'Pre-lancio · Rotte verificate',
  },
  activeRoutes: {
    sectionLabel: '05 · Rotte attive',
    headline: "L'Europa parte.",
    headlineAccent: 'Buenos Aires aspetta.',
    tagline: 'Cinque corridoi. Una direzione. Trasportiamo solo ciò che vola già.',
    routePrefix: 'ROTA',
    originLabel: 'Origine',
    destLabel: 'Destinazione',
    flightLabel: 'Volo',
    openLabel: 'Aperto',
    routes: [
      { fromCity: 'Berlino', fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',  fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Roma',    fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Parigi',  fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lisbona', fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Servizi',
    title: 'Servizi',
    buyer: {
      label: 'Per acquirenti',
      title: 'Trova ciò che non arriva nel tuo Paese',
      body: 'Pubblica ciò che ti serve e connettiti con un viaggiatore verificato che sta già facendo il viaggio. Accedi a prodotti ai prezzi d’origine, senza intermediari.',
      cta: 'Pubblica una richiesta',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlino → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Roma → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'Parigi → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'Per viaggiatori',
      title: 'Monetizza lo spazio libero nel bagaglio',
      body: 'Viaggi tra Europa e Sudamerica? Pubblica la tua rotta e i prodotti che puoi trasportare. Ammortizza parte del viaggio e costruisci reputazione come viaggiatore affidabile.',
      cta: 'Registrati come viaggiatore',
      routes: [
        { route: 'Berlino → Buenos Aires', activeTravelers: 'HQ · 3 viaggiatori attivi' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 viaggiatori attivi' },
        { route: 'Roma → Buenos Aires', activeTravelers: '5 viaggiatori attivi' },
        { route: 'Parigi → Buenos Aires', activeTravelers: '4 viaggiatori attivi' },
        { route: 'Lisbona → Buenos Aires', activeTravelers: '7 viaggiatori attivi' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Domande frequenti',
    subtitle: '',
    items: [
      {
        question: 'Come mi registro su Bringy?',
        answer:
          'Compila il modulo con nome, email e se vuoi acquistare o viaggiare. Ti contatteremo entro 24 ore per guidarti nei primi passi.',
      },
      {
        question: 'Chi può essere viaggiatore?',
        answer:
          'Chiunque abbia più di 18 anni e viaggi regolarmente tra Europa e Sudamerica. È richiesta la verifica d’identità prima di pubblicare rotte attive.',
      },
      {
        question: 'Come so se il viaggiatore è affidabile?',
        answer:
          'Ogni viaggiatore ha un profilo con livello di verifica, storico consegne e valutazioni degli altri utenti. Più storico, più fiducia.',
      },
      {
        question: 'Cosa succede al mio denaro se il prodotto non arriva?',
        answer:
          'I fondi restano in escrow fino alla conferma di ricezione. In caso di problema, il team Bringy interviene e media tra le parti.',
      },
      {
        question: 'Quali prodotti posso richiedere?',
        answer:
          'Qualsiasi prodotto legale trasportabile in cabina o in stiva secondo le normative doganali del Paese di destinazione: elettronica, abbigliamento, cosmetici, alimenti non deperibili, documenti, ecc.',
      },
      {
        question: 'Quanto costa Bringy?',
        answer:
          'Una commissione dall’8 al 10% su ogni transazione completata. I viaggiatori frequenti possono accedere all’abbonamento Pro a 9 €/mese, che elimina la commissione e offre maggiore visibilità.',
      },
      {
        question: 'Posso richiedere una consegna con verifica live?',
        answer:
          'Sì. Per transazioni di alto valore o se entrambe le parti preferiscono, un rappresentante Bringy entra in videochiamata, verifica le identità e documenta lo scambio.',
      },
      {
        question: 'Su quali rotte siete attivi?',
        answer:
          'Operiamo rotte da Berlino (HQ), Madrid, Roma, Parigi e Lisbona — tutte con destinazione Buenos Aires. Aggiungiamo nuove rotte in base alla domanda della community.',
      },
      {
        question: 'Quali metodi di pagamento accettate?',
        answer:
          'Carte Visa, Mastercard e Amex. Stripe per pagamenti internazionali con carta da qualsiasi Paese. Bonifici SEPA in Europa. Mercado Pago in Sudamerica. Rilascio fondi entro 1–2 giorni lavorativi dopo la conferma di consegna.',
      },
    ],
  },
  globe: {
    cities: ['Berlino ★', 'Madrid', 'Roma', 'Parigi', 'Lisboa', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: 'Hai una domanda o vuoi entrare?',
    subtitle:
      'Siamo in fase di lancio e vogliamo conoscere il tuo caso. Compila il modulo: un membro del team ti contatterà entro le prossime 24 ore.',
    emailLabel: 'Puoi anche scriverci a',
  },
  footer: {
    copyright: '© {year} Bringy. Tutti i diritti riservati.',
    tagline: 'Persone reali. Prodotti reali. Rotte verificate.',
    hubBerlin: 'Berlino',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'Come funziona',
      whyUs: 'Perché Bringy',
      offerings: 'Servizi',
      faq: 'Domande frequenti',
      contact: 'Contatti',
      impressum: 'Impressum',
      privacy: 'Informativa sulla privacy',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Realizzato da',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Torna alla home',
    placeholderNotice:
      'Campi contrassegnati [COMPLETAR] in attesa della costituzione dell’ente giuridico.',
    privacy: {
      title: 'Informativa sulla privacy',
      body: privacyBody,
    },
    terms: {
      title: 'Termini di utilizzo',
      body: 'Bringy opera come piattaforma intermediaria tra acquirenti e viaggiatori. L’uso implica accettazione della verifica d’identità, trasporto solo di prodotti legali e risoluzione delle controversie secondo i termini della piattaforma. Testo definitivo in attesa di pubblicazione.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Apri menu',
    closeMenu: 'Chiudi menu',
    chooseLanguage: 'Scegli lingua',
  },
  forms: {
    backHome: 'Torna alla home',
    submit: 'Invia richiesta',
    successTitle: 'Abbiamo ricevuto la tua richiesta!',
    successBody:
      'Ti contatteremo entro le prossime 24 ore per definire i dettagli. Benvenuto/a su Bringy.',
    fields: {
      name: { label: 'Nome e cognome', placeholder: 'Il tuo nome completo' },
      email: { label: 'Email', placeholder: 'tuo@email.com' },
      role: {
        label: 'Io sono…',
        placeholder: 'Seleziona un’opzione',
        buyer: 'Acquirente',
        traveler: 'Viaggiatore',
      },
      countryRoute: {
        label: 'Rotta di interesse',
        placeholder: 'Es.: Madrid → Buenos Aires',
        other: 'Altra rotta',
      },
      message: {
        label: 'Prodotto o messaggio',
        placeholder: 'Raccontaci che prodotto cerchi o cosa puoi trasportare',
        optional: 'Facoltativo',
      },
    },
    errors: {
      required: 'Compila questo campo',
      email: 'Inserisci un’email valida',
      role: 'Seleziona un’opzione',
      submitFailed: 'Impossibile inviare il modulo. Riprova.',
    },
    sending: 'Invio in corso…',
    privacyNote:
      'Inviando accetti che usiamo questi dati per contattarti su Bringy. Consulta la nostra',
    defaultDescriptions: {
      requestItem: 'Richiesta dal modulo di contatto',
      becomeTraveler: 'Registrazione viaggiatore dal modulo di contatto',
    },
    requestItem: {
      title: 'Cerca un prodotto',
      subtitle: 'Raccontaci di cosa hai bisogno — ti rispondiamo entro 24 ore.',
    },
    becomeTraveler: {
      title: 'Offri come viaggiatore',
      subtitle: 'Indicaci la tua rotta — ti rispondiamo entro 24 ore.',
    },
  },
}
